import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import GlobalOffices from "../components/globalOffices"
import ImageTween from "../components/imageTween"
import Lightbox from "../components/Lightbox/Lightbox"

const Retail = () => {
  const lang = "en"

  const tiles = [
    {
      title: "Gastronomy",
      items: [
        {
          label: "Salvia Restaurant",
          description: "<p>Aleksandra Lubomirskiego 24</p>",
          url: "https://www.salvia.com.pl/",
        },
        {
          label: "Filini Restaurant & Bar",
          description:
            "<p>Aleksandra Lubomirskiego 16<br/> (Radisson RED Hotel)</p>",
          url:
            "https://www.radissonhotels.com/pl-pl/hotele/radisson-red-krakow/restauracje-i-bary/filini",
        },
        {
          label: "The Miners Coffee",
          description: "<p>Aleksandra Lubomirskiego 20</p>",
          url: "https://www.theminers.eu/",
        },
        {
          label: "Unity Eye",
          description:
            "<p>Aleksandra Lubomirskiego 20</p><p>Booking and information:<br/> <a href='mailto:kontakt@eyetop.pl'>kontakt@eyetop.pl</a><br/> <a href='tel:+48570325944'>+48 570 325 944</a></p>",
          url: "https://www.eye.top/",
        },
      ],
    },
    {
      title: "Shops & Services",
      items: [
        {
          label: "Miele Experience Center",
          description: "<p>Aleksandra Lubomirskiego 24</p>",
          url: "https://www.miele.pl/",
        },
        {
          label: "Enterprise Rent A Car",
          description: "<p>Aleksandra Lubomirskiego 20</p>",
          url: "https://www.enterpriserentacar.pl/en/home.html",
        },
        {
          label: "Optiland",
          description: "<p>Aleksandra Lubomirskiego 22</p>",
          url: "https://optiland.online/",
        },
        {
          label: "Żabka",
          description: "<p>Aleksandra Lubomirskiego 22</p>",
          url: "https://www.zabka.pl/",
        },
        {
          label: "EMPOWER PILATES",
          description: "<p>Aleksandra Lubomirskiego 22</p>",
          url: 'https://empowerpilates.pl/studio-krakow/'
        },
        {
          label: "Bank ING",
          description: "<p>Aleksandra Lubomirskiego 16</p>",
          url: "https://www.ing.pl/",
        }
      ],
    },
    {
      title: "Entertainment",
      items: [
        {
          label: "Arcade Bee",
          description: "<p>Aleksandra Lubomirskiego 24</p>",
          url: "https://arcadebee.com/",
        },
      ],
    },
  ]

  return (
    <Layout lang={lang} translation="/pl/lokale/">
      <SEO title="Retail" />

      {/* <section className="home-top">
        <div className="global__padd">
          <div className="home-top__wrapper">
            <h2>
              UNITY <br /> <span>Centre</span>
            </h2>
            <h2>Krakow's Business Complex</h2>
          </div>
          <ImageTween src={require("../assets/images/_I8A8396.jpg")} alt="" />
        </div>
      </section> */}

      {/* <section className="retail-top global__padd--bigger">
        <h2>A good stretch</h2>
        <p>
          Nothing can create a sense of place quite like a lively neighborhood
          populated with shops, cafes, and kiosks. It boosts the economy, brings
          people together and offers entrepreneurs a space to start their own
          businesses. Times are changing - and so is the nature of the retail
          and hospitality industry - but the need for a space to showcase wares,
          nurture interaction and curiosity will never fade. These stretches can
          benefit the entire community.
        </p>
      </section> */}

      <section className="retail-tiles global__padd--bigger">
        <div className="row">
          {tiles.map((tile, index) => (
            <div className="col-xl-4 col-md-6" key={index}>
              <div className="retail-tiles__item">
                <h3>{tile.title}</h3>
                {tile?.items?.length > 0 &&
                  tile.items.map((item, index) => {
                    const url = item?.url
                    const Tag = url ? "a" : "span"

                    return (
                      <div key={index} className="retail-tiles__item-details">
                        <h4>
                          <Tag
                            href={url}
                            target={!!url ? "_blank" : undefined}
                            rel={
                              !!url ? "noopener noreferrer nofollow" : undefined
                            }
                          >
                            {item.label}
                          </Tag>
                        </h4>
                        {item.description && (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: item.description,
                            }}
                          />
                        )}
                      </div>
                    )
                  })}
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="retail-content global__padd--bigger">
        <div className="row no-gutters align-items-center">
          <div className="col-lg-7">
            <div className="retail-content__inner sticky-wrapper">
              <h2>UNITY Square</h2>
              <p>
                Plentiful, accessible and exciting public space is a fundamental
                element of urban life. The central part of the complex
                encourages people to spend more time outdoors in restaurants,
                cafes, exhibition areas, service points and green spots. Your
                next destination at the fingertips.
              </p>
            </div>
          </div>
          <div className="col-lg-5">
            <ImageTween
              src={require("../assets/images/retail-content-image-1_new.jpg")}
              srcSet={require("../assets/images/retail-content-image-1_new@2x.jpg")}
              alt=""
            />
          </div>
        </div>

        <div className="row no-gutters flex-column-reverse flex-md-row align-items-center">
          <div className="col-lg-5">
            <ImageTween
              src={require("../assets/images/retail-content-image-2.jpg")}
              srcSet={require("../assets/images/retail-content-image-2@2x.jpg")}
              alt=""
            />
          </div>
          <div className="col-lg-7">
            <div className="retail-content__inner sticky-wrapper">
              <h2>UNITY Retail</h2>
              <p>
                We are able to provide you with a vibrant link between great
                location and your customers, offering a range of retail and
                hospitality spaces for discerning urban tenants. It is an ideal
                space for a flagship store, kiosk, restaurant, beauty salon or
                flower shop. The UNITY CENTRE complex will ensure high foot
                traffic and a regular clientele.
              </p>
              <div className="retail-content__inner-action">
                <Lightbox
                  ctaType="button"
                  ctaText="See our retail units"
                  ctaClass="btn-custom-back btn-custom-back--orange"
                  imageSrc={require("../assets/images/retail-content-image-retail-units-en-v2.jpg")}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="row no-gutters align-items-center">
          <div className="col-lg-7">
            <div className="retail-content__inner sticky-wrapper">
              <h2>UNITY Hotel</h2>
              <p>
                Radisson RED Hotel is a vibrant place that combines music and
                creativity in an innovative way. Right from the entrance to the
                hotel lobby, the open atrium with panoramic elevators and a
                local accent - a red sculpture of the Wawel dragon in the RED
                style - make a huge impression. The hotel offers 229 carefully
                decorated rooms, a conference floor and a fitness area.
                Additionally, the hotel's Filini Restaurant & Bar invites you on
                a culinary journey through Italy.
              </p>
              <p>
                This four-star hotel stands out for its fresh approach to
                traditional hospitality, combining stylish interiors with an
                energetic atmosphere.
              </p>
            </div>
          </div>
          <div className="col-lg-5">
            <ImageTween
              src={require("../assets/images/PG_240619_304.jpg")}
              alt=""
            />
          </div>
        </div>

        <div className="row no-gutters flex-column-reverse flex-md-row align-items-center">
          <div className="col-lg-5">
            <ImageTween
              src={require("../assets/images/PG_240619_119.jpg")}
              alt=""
            />
          </div>
          <div className="col-lg-7">
            <div className="retail-content__inner sticky-wrapper">
              <h2>UNITY Residence</h2>
              <p>
                Radisson RED Apartments offers 46 spacious apartments for
                long-term stays. Guests can choose from studio or separate
                bedroom apartments, which are equipped with kitchenettes. Most
                of these apartments also have a covered terrace, allowing for
                outdoor relaxation.
              </p>
              <p>
                A bold design that combines modern elements and high-level
                amenities provides an exceptional experience during your stay.
                The apartments have been designed in accordance with the hotel
                standard, offering everything you need for comfortable and
                long-term accommodation.
              </p>
            </div>
          </div>
        </div>
      </section>

      <GlobalOffices lang={lang} retail />
    </Layout>
  )
}

export default Retail
